import { HeatingCircuit } from 'z3k-config';
import { getConsumerControlConfig } from '../utils';
import { getZ3KControlConfig, getZ3KHeatingCircuitThermometersConfig, isHeatingCircuitHidden, isNeedBoiler, } from './utils';
import { partial } from 'webui/utils/functions';
import { setZ3kTargetTemp } from 'console/redux/z3k-target-temp/action';
import { fixObjectName } from 'z3k-settings/utils/fix-object-name';
export function getZ3KHeatingCircuitsConfig(device_id, z3k_config, show_hidden_elements = false) {
    const heating_circuits = HeatingCircuit.get.where(z3k_config, partial(isNeedBoiler, false));
    const shared_heating_circuits_configs = heating_circuits.map((z3k_circuit) => {
        const { id, name } = z3k_circuit;
        const control_config = getZ3KControlConfig(z3k_circuit);
        const control_mode_config = getConsumerControlConfig(control_config);
        const is_hidden = isHeatingCircuitHidden(z3k_circuit) && !show_hidden_elements;
        if (is_hidden) {
            return null;
        }
        const thermometers_config = getZ3KHeatingCircuitThermometersConfig(z3k_config, z3k_circuit);
        const onTargetTemperatureChange = partial(setZ3kTargetTemp, device_id, id);
        return {
            id,
            name: fixObjectName(name),
            control_mode_config,
            thermometers_config,
            onTargetTemperatureChange,
            z3k_circuit,
            ...control_config,
        };
    });
    return shared_heating_circuits_configs;
}
